import React from 'react';
import styles from './NoDataContainer.module.scss';
import { NO_DATA_PLACEHOLDER } from '../../config/constant/assetConstant';
import { REQUESTS_ROUTE } from '../../config/constant/routePathConstant';
import { MY_FILES, MY_PRODUCTS, COLLECTIONS_ROUTE } from '../../constants/routePathConstants';

export default function NoDataContainer({ title = "You don't have any Data", actionBtn = null }) {
  const isMyFilesInURL = () => {
    if(window?.location?.href?.includes(MY_FILES)){
      return styles.myFileSection
    }
    if(window?.location?.href?.includes(MY_PRODUCTS)){
      return styles.myProductSection
    }
    if(window?.location?.href?.includes(COLLECTIONS_ROUTE) || window?.location?.href?.includes(`${COLLECTIONS_ROUTE}/`)){
      return styles.myCollectionSection
    }
    if(window?.location?.href?.includes(REQUESTS_ROUTE)){
      return styles.requestSection
    }
  };

  return (
    <div className={`${styles.rootContainer} ${isMyFilesInURL()}`}>
      <img className={styles.placeholderImg} src={NO_DATA_PLACEHOLDER} alt="noData" />
      <h3>{title}</h3>
      {actionBtn}
    </div>
  );
}
